// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AiRouteImport } from './routes/ai'
import { Route as AiFakturaanalysRouteImport } from './routes/ai-fakturaanalys'
import { Route as AiPrognoserRouteImport } from './routes/ai-prognoser'
import { Route as AngerKlagomalRouteImport } from './routes/anger-klagomal'
import { Route as AnvandarvillkorRouteImport } from './routes/anvandarvillkor'
import { Route as AppIntegritetspolicyRouteImport } from './routes/app-integritetspolicy'
import { Route as AppVillkorRouteImport } from './routes/app-villkor'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BekraftaEpostRouteImport } from './routes/bekrafta-epost'
import { Route as CompricerRouteImport } from './routes/compricer'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as DagensElpriserRouteImport } from './routes/dagens-elpriser'
import { Route as DataskyddspolicyRouteImport } from './routes/dataskyddspolicy'
import { Route as DiagramTabellerRouteImport } from './routes/diagram-tabeller'
import { Route as ElbrukRouteImport } from './routes/elbruk'
import { Route as ElbyteRouteImport } from './routes/elbyte'
import { Route as ElmarknadAiRouteImport } from './routes/elmarknad-ai'
import { Route as ElprisApiRouteImport } from './routes/elpris-api'
import { Route as ElpriskollenRouteImport } from './routes/elpriskollen'
import { Route as ElsklingRouteImport } from './routes/elskling'
import { Route as FelanmalanRouteImport } from './routes/felanmalan'
import { Route as ForLlmsRouteImport } from './routes/for-llms'
import { Route as ForfraganForetagBrfRouteImport } from './routes/forfragan-foretag-brf'
import { Route as FragorSvarRouteImport } from './routes/fragor-svar'
import { Route as HittaElbolagRouteImport } from './routes/hitta-elbolag'
import { Route as HittaElnatsomradeRouteImport } from './routes/hitta-elnatsomrade'
import { Route as HittaElomradeRouteImport } from './routes/hitta-elomrade'
import { Route as HittaNatagareRouteImport } from './routes/hitta-natagare'
import { Route as JamforOffertRouteImport } from './routes/jamfor-offert'
import { Route as JobbaHosOssRouteImport } from './routes/jobba-hos-oss'
import { Route as KalkylatorerRouteImport } from './routes/kalkylatorer'
import { Route as KassaRouteImport } from './routes/kassa'
import { Route as KompletteraAnlaggningsidRouteImport } from './routes/komplettera-anlaggningsid'
import { Route as KompletteraAnlaggningsidTestRouteImport } from './routes/komplettera-anlaggningsid-test'
import { Route as KompletteraUppgifterRouteImport } from './routes/komplettera-uppgifter'
import { Route as KompletteraUppgifterTestRouteImport } from './routes/komplettera-uppgifter-test'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as LamnaFeedbackRouteImport } from './routes/lamna-feedback'
import { Route as LamnaOmdomeRouteImport } from './routes/lamna-omdome'
import { Route as LamnaSynpunktRouteImport } from './routes/lamna-synpunkt'
import { Route as LoggaInRouteImport } from './routes/logga-in'
import { Route as MinaElpriserRouteImport } from './routes/mina-elpriser'
import { Route as MinaSidorRouteImport } from './routes/mina-sidor'
import { Route as MittAvtalRouteImport } from './routes/mitt-avtal'
import { Route as MittElprisRouteImport } from './routes/mitt-elpris'
import { Route as MobilappRouteImport } from './routes/mobilapp'
import { Route as MorgondagensElpriserRouteImport } from './routes/morgondagens-elpriser'
import { Route as OffertforfraganRouteImport } from './routes/offertforfragan'
import { Route as OmOssRouteImport } from './routes/om-oss'
import { Route as PartnerRouteImport } from './routes/partner'
import { Route as PartneransokanRouteImport } from './routes/partneransokan'
import { Route as PersonligEnergianalysRouteImport } from './routes/personlig-energianalys'
import { Route as PressRouteImport } from './routes/press'
import { Route as ProduktionsstatusRouteImport } from './routes/produktionsstatus'
import { Route as PrognosApiRouteImport } from './routes/prognos-api'
import { Route as SaveraRouteImport } from './routes/savera'
import { Route as SkapaArendeRouteImport } from './routes/skapa-arende'
import { Route as SokRouteImport } from './routes/sok'
import { Route as SokresultatRouteImport } from './routes/sokresultat'
import { Route as SokresultatTestRouteImport } from './routes/sokresultat-test'
import { Route as SolcellsofferterRouteImport } from './routes/solcellsofferter'
import { Route as SpontanansokanRouteImport } from './routes/spontanansokan'
import { Route as StartRouteImport } from './routes/start'
import { Route as TackForetagRouteImport } from './routes/tack-foretag'
import { Route as TackOffertRouteImport } from './routes/tack-offert'
import { Route as ValjLosenordRouteImport } from './routes/valj-losenord'
import { Route as VerktygTjansterRouteImport } from './routes/verktyg-tjanster'
import { Route as VilketElbolagRouteImport } from './routes/vilket-elbolag'
import { Route as ZmartaRouteImport } from './routes/zmarta'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAdministratorerRouteImport } from './routes/admin/administratorer'
import { Route as AdminAiChattRouteImport } from './routes/admin/ai-chatt'
import { Route as AdminAnnonsorerRouteImport } from './routes/admin/annonsorer'
import { Route as AdminAnvandareRouteImport } from './routes/admin/anvandare'
import { Route as AdminAvtalsApiRouteImport } from './routes/admin/avtals-api'
import { Route as AdminAvtalsbytenRouteImport } from './routes/admin/avtalsbyten'
import { Route as AdminBetygRouteImport } from './routes/admin/betyg'
import { Route as AdminBildrapportRouteImport } from './routes/admin/bildrapport'
import { Route as AdminDokumentdataRouteImport } from './routes/admin/dokumentdata'
import { Route as AdminElavtalRouteImport } from './routes/admin/elavtal'
import { Route as AdminElhandelsbolagRouteImport } from './routes/admin/elhandelsbolag'
import { Route as AdminFullmakterRouteImport } from './routes/admin/fullmakter'
import { Route as AdminGodkannandenRouteImport } from './routes/admin/godkannanden'
import { Route as AdminHistorikRouteImport } from './routes/admin/historik'
import { Route as AdminInnehallRouteImport } from './routes/admin/innehall'
import { Route as AdminInstallningarRouteImport } from './routes/admin/installningar'
import { Route as AdminIntresseRouteImport } from './routes/admin/intresse'
import { Route as AdminKampanjerRouteImport } from './routes/admin/kampanjer'
import { Route as AdminKunderRouteImport } from './routes/admin/kunder'
import { Route as AdminKundregisterRouteImport } from './routes/admin/kundregister'
import { Route as AdminLaddstationerRouteImport } from './routes/admin/laddstationer'
import { Route as AdminLeadpartnersRouteImport } from './routes/admin/leadpartners'
import { Route as AdminLeadsRouteImport } from './routes/admin/leads'
import { Route as AdminLogotyperRouteImport } from './routes/admin/logotyper'
import { Route as AdminMailmallarRouteImport } from './routes/admin/mailmallar'
import { Route as AdminMejlgranskningRouteImport } from './routes/admin/mejlgranskning'
import { Route as AdminMinaSidorRouteImport } from './routes/admin/mina-sidor'
import { Route as AdminNyheterRouteImport } from './routes/admin/nyheter'
import { Route as AdminNyhetsbrevRouteImport } from './routes/admin/nyhetsbrev'
import { Route as AdminOmdirigeringarRouteImport } from './routes/admin/omdirigeringar'
import { Route as AdminPrisfilerRouteImport } from './routes/admin/prisfiler'
import { Route as AdminProdukterRouteImport } from './routes/admin/produkter'
import { Route as AdminPrognosApiRouteImport } from './routes/admin/prognos-api'
import { Route as AdminRapporterRouteImport } from './routes/admin/rapporter'
import { Route as AdminRapportfilerRouteImport } from './routes/admin/rapportfiler'
import { Route as AdminReturerRouteImport } from './routes/admin/returer'
import { Route as AdminSeoRouteImport } from './routes/admin/seo'
import { Route as AdminSocialaMedierRouteImport } from './routes/admin/sociala-medier'
import { Route as AdminSokinsikterRouteImport } from './routes/admin/sokinsikter'
import { Route as AdminSokresultatRouteImport } from './routes/admin/sokresultat'
import { Route as AdminSpotpriserRouteImport } from './routes/admin/spotpriser'
import { Route as AdminTrenderRouteImport } from './routes/admin/trender'
import { Route as AdminVerktygRouteImport } from './routes/admin/verktyg'
import { Route as BatterierIndexRouteImport } from './routes/batterier/index'
import { Route as BatterierSlugRouteImport } from './routes/batterier/$slug'
import { Route as BatterierBatterikalkylatorRouteImport } from './routes/batterier/batterikalkylator'
import { Route as BatterierOffertRouteImport } from './routes/batterier/offert'
import { Route as BliPartnerIndexRouteImport } from './routes/bli-partner/index'
import { Route as BliPartnerSlugRouteImport } from './routes/bli-partner/$slug'
import { Route as BloggIndexRouteImport } from './routes/blogg/index'
import { Route as BloggSlugRouteImport } from './routes/blogg/$slug'
import { Route as DagensSpotprisIndexRouteImport } from './routes/dagens-spotpris/index'
import { Route as DagensSpotprisSlugRouteImport } from './routes/dagens-spotpris/$slug'
import { Route as ElavtalIndexRouteImport } from './routes/elavtal/index'
import { Route as ElavtalSlugRouteImport } from './routes/elavtal/$slug'
import { Route as ElavtalAnvisatRouteImport } from './routes/elavtal/anvisat'
import { Route as ElavtalAvtalsvaljarenRouteImport } from './routes/elavtal/avtalsvaljaren'
import { Route as ElavtalBastaRouteImport } from './routes/elavtal/basta'
import { Route as ElavtalBestallRouteImport } from './routes/elavtal/bestall'
import { Route as ElavtalBilligaRouteImport } from './routes/elavtal/billiga'
import { Route as ElavtalBindaRouteImport } from './routes/elavtal/binda'
import { Route as ElavtalBlackFridayRouteImport } from './routes/elavtal/black-friday'
import { Route as ElavtalBrfRouteImport } from './routes/elavtal/brf'
import { Route as ElavtalBytRouteImport } from './routes/elavtal/byt'
import { Route as ElavtalFastRouteImport } from './routes/elavtal/fast'
import { Route as ElavtalForetagRouteImport } from './routes/elavtal/foretag'
import { Route as ElavtalForstaGangenRouteImport } from './routes/elavtal/forsta-gangen'
import { Route as ElavtalFritidshusRouteImport } from './routes/elavtal/fritidshus'
import { Route as ElavtalJamforRouteImport } from './routes/elavtal/jamfor'
import { Route as ElavtalJamforTestRouteImport } from './routes/elavtal/jamfor-test'
import { Route as ElavtalKvartsprisRouteImport } from './routes/elavtal/kvartspris'
import { Route as ElavtalLagenhetRouteImport } from './routes/elavtal/lagenhet'
import { Route as ElavtalManadsprisRouteImport } from './routes/elavtal/manadspris'
import { Route as ElavtalMixprisRouteImport } from './routes/elavtal/mixpris'
import { Route as ElavtalPensionarRouteImport } from './routes/elavtal/pensionar'
import { Route as ElavtalPensionarerRouteImport } from './routes/elavtal/pensionarer'
import { Route as ElavtalPortfoljRouteImport } from './routes/elavtal/portfolj'
import { Route as ElavtalRorligtRouteImport } from './routes/elavtal/rorligt'
import { Route as ElavtalSagUppRouteImport } from './routes/elavtal/sag-upp'
import { Route as ElavtalStudentRouteImport } from './routes/elavtal/student'
import { Route as ElavtalStudenterRouteImport } from './routes/elavtal/studenter'
import { Route as ElavtalTecknaRouteImport } from './routes/elavtal/teckna'
import { Route as ElavtalTillsvidareRouteImport } from './routes/elavtal/tillsvidare'
import { Route as ElavtalTimprisRouteImport } from './routes/elavtal/timpris'
import { Route as ElavtalVidFlyttRouteImport } from './routes/elavtal/vid-flytt'
import { Route as ElavtalVillaRouteImport } from './routes/elavtal/villa'
import { Route as ElavtalVintersakratRouteImport } from './routes/elavtal/vintersakrat'
import { Route as ElbolagIndexRouteImport } from './routes/elbolag/index'
import { Route as ElbolagSlugRouteImport } from './routes/elbolag/$slug'
import { Route as ElbolagBastaRouteImport } from './routes/elbolag/basta'
import { Route as ElbolagBilligasteRouteImport } from './routes/elbolag/billigaste'
import { Route as ElbolagBytRouteImport } from './routes/elbolag/byt'
import { Route as ElbolagElhandelRouteImport } from './routes/elbolag/elhandel'
import { Route as ElbolagElnatRouteImport } from './routes/elbolag/elnat'
import { Route as ElbolagJamforRouteImport } from './routes/elbolag/jamfor'
import { Route as ElhandelIndexRouteImport } from './routes/elhandel/index'
import { Route as ElhandelSlugRouteImport } from './routes/elhandel/$slug'
import { Route as ElmarknadenIndexRouteImport } from './routes/elmarknaden/index'
import { Route as ElmarknadenAvregleringenRouteImport } from './routes/elmarknaden/avregleringen'
import { Route as ElmarknadenFramtidenRouteImport } from './routes/elmarknaden/framtiden'
import { Route as ElmarknadenHistoriaRouteImport } from './routes/elmarknaden/historia'
import { Route as ElmarknadenSaFungerarElmarknadenRouteImport } from './routes/elmarknaden/sa-fungerar-elmarknaden'
import { Route as ElnatIndexRouteImport } from './routes/elnat/index'
import { Route as ElnatSlugRouteImport } from './routes/elnat/$slug'
import { Route as ElpriserIndexRouteImport } from './routes/elpriser/index'
import { Route as ElpriserSlugRouteImport } from './routes/elpriser/$slug'
import { Route as ElpriserElomrade1RouteImport } from './routes/elpriser/elomrade-1'
import { Route as ElpriserElomrade2RouteImport } from './routes/elpriser/elomrade-2'
import { Route as ElpriserElomrade3RouteImport } from './routes/elpriser/elomrade-3'
import { Route as ElpriserElomrade4RouteImport } from './routes/elpriser/elomrade-4'
import { Route as ElpriserFastRouteImport } from './routes/elpriser/fast'
import { Route as ElpriserIdagRouteImport } from './routes/elpriser/idag'
import { Route as ElpriserImorgonRouteImport } from './routes/elpriser/imorgon'
import { Route as ElpriserJamforRouteImport } from './routes/elpriser/jamfor'
import { Route as ElpriserKvartsprisRouteImport } from './routes/elpriser/kvartspris'
import { Route as ElpriserManadsprisRouteImport } from './routes/elpriser/manadspris'
import { Route as ElpriserNordpoolRouteImport } from './routes/elpriser/nordpool'
import { Route as ElpriserPrognosRouteImport } from './routes/elpriser/prognos'
import { Route as ElpriserRorligtRouteImport } from './routes/elpriser/rorligt'
import { Route as ElpriserSe1RouteImport } from './routes/elpriser/se1'
import { Route as ElpriserSe2RouteImport } from './routes/elpriser/se2'
import { Route as ElpriserSe3RouteImport } from './routes/elpriser/se3'
import { Route as ElpriserSe4RouteImport } from './routes/elpriser/se4'
import { Route as ElpriserTimprisRouteImport } from './routes/elpriser/timpris'
import { Route as HembatterierSlugRouteImport } from './routes/hembatterier/$slug'
import { Route as HembatterierOffertRouteImport } from './routes/hembatterier/offert'
import { Route as HistoriskaElpriserIndexRouteImport } from './routes/historiska-elpriser/index'
import { Route as HistoriskaElpriserRestRouteImport } from './routes/historiska-elpriser/$rest'
import { Route as JamforOfferterIndexRouteImport } from './routes/jamfor-offerter/index'
import { Route as JamforOfferterSlugRouteImport } from './routes/jamfor-offerter/$slug'
import { Route as KommersiellaBatterierIndexRouteImport } from './routes/kommersiella-batterier/index'
import { Route as KommersiellaBatterierSlugRouteImport } from './routes/kommersiella-batterier/$slug'
import { Route as KommersiellaBatterierOffertRouteImport } from './routes/kommersiella-batterier/offert'
import { Route as KommersiellaSolcellerIndexRouteImport } from './routes/kommersiella-solceller/index'
import { Route as KommersiellaSolcellerSlugRouteImport } from './routes/kommersiella-solceller/$slug'
import { Route as KommersiellaSolcellerOffertRouteImport } from './routes/kommersiella-solceller/offert'
import { Route as KommunIndexRouteImport } from './routes/kommun/index'
import { Route as KommunSlugRouteImport } from './routes/kommun/$slug'
import { Route as LaddboxarIndexRouteImport } from './routes/laddboxar/index'
import { Route as LaddboxarSlugRouteImport } from './routes/laddboxar/$slug'
import { Route as LaddboxarLaddboxkalkylatorRouteImport } from './routes/laddboxar/laddboxkalkylator'
import { Route as LaddboxarOffertRouteImport } from './routes/laddboxar/offert'
import { Route as LaddstationerIndexRouteImport } from './routes/laddstationer.index'
import { Route as LaddstationerSlugRouteImport } from './routes/laddstationer.$slug'
import { Route as LaddstolparIndexRouteImport } from './routes/laddstolpar/index'
import { Route as LaddstolparSlugRouteImport } from './routes/laddstolpar/$slug'
import { Route as LaddstolparOffertRouteImport } from './routes/laddstolpar/offert'
import { Route as MinaSidorIndexRouteImport } from './routes/mina-sidor/index'
import { Route as MinaSidorAnalyserRouteImport } from './routes/mina-sidor/analyser'
import { Route as MinaSidorAnlaggningarRouteImport } from './routes/mina-sidor/anlaggningar'
import { Route as MinaSidorAvtalsforfragningarRouteImport } from './routes/mina-sidor/avtalsforfragningar'
import { Route as MinaSidorElavtalRouteImport } from './routes/mina-sidor/elavtal'
import { Route as MinaSidorFaktureringRouteImport } from './routes/mina-sidor/fakturering'
import { Route as MinaSidorFakturorRouteImport } from './routes/mina-sidor/fakturor'
import { Route as MinaSidorForbrukningRouteImport } from './routes/mina-sidor/forbrukning'
import { Route as MinaSidorForfragningarRouteImport } from './routes/mina-sidor/forfragningar'
import { Route as MinaSidorFullmakterRouteImport } from './routes/mina-sidor/fullmakter'
import { Route as MinaSidorInstallningarRouteImport } from './routes/mina-sidor/installningar'
import { Route as MinaSidorKontoinstallningarRouteImport } from './routes/mina-sidor/kontoinstallningar'
import { Route as MinaSidorNotiserRouteImport } from './routes/mina-sidor/notiser'
import { Route as MinaSidorOffertforfragningarRouteImport } from './routes/mina-sidor/offertforfragningar'
import { Route as MinaSidorProfilRouteImport } from './routes/mina-sidor/profil'
import { Route as MinaSidorRapporterRouteImport } from './routes/mina-sidor/rapporter'
import { Route as MinaSidorVerktygRouteImport } from './routes/mina-sidor/verktyg'
import { Route as NyheterIndexRouteImport } from './routes/nyheter/index'
import { Route as NyheterSlugRouteImport } from './routes/nyheter/$slug'
import { Route as OfferterIndexRouteImport } from './routes/offerter/index'
import { Route as OrdlistaIndexRouteImport } from './routes/ordlista/index'
import { Route as OrdlistaTermRouteImport } from './routes/ordlista/$term'
import { Route as PartnerIndexRouteImport } from './routes/partner/index'
import { Route as PartnerFaktureringRouteImport } from './routes/partner/fakturering'
import { Route as PartnerImportRouteImport } from './routes/partner/import'
import { Route as PartnerKampanjerRouteImport } from './routes/partner/kampanjer'
import { Route as PartnerLeadsRouteImport } from './routes/partner/leads'
import { Route as PartnerProfilRouteImport } from './routes/partner/profil'
import { Route as PressreleaserIndexRouteImport } from './routes/pressreleaser/index'
import { Route as PressreleaserSlugRouteImport } from './routes/pressreleaser/$slug'
import { Route as ProdukterIndexRouteImport } from './routes/produkter/index'
import { Route as RapporterIndexRouteImport } from './routes/rapporter/index'
import { Route as RapporterSlugRouteImport } from './routes/rapporter/$slug'
import { Route as RapporterElprisetISverigeRouteImport } from './routes/rapporter.elpriset-i-sverige'
import { Route as SolcellerIndexRouteImport } from './routes/solceller/index'
import { Route as SolcellerSlugRouteImport } from './routes/solceller/$slug'
import { Route as SolcellerOffertRouteImport } from './routes/solceller/offert'
import { Route as SolcellerSolcellskalkylatorRouteImport } from './routes/solceller/solcellskalkylator'
import { Route as SpotprisIndexRouteImport } from './routes/spotpris/index'
import { Route as SpotprisSlugRouteImport } from './routes/spotpris/$slug'
import { Route as SpotprisElomradeSe1RouteImport } from './routes/spotpris/elomrade-se1'
import { Route as SpotprisElomradeSe2RouteImport } from './routes/spotpris/elomrade-se2'
import { Route as SpotprisElomradeSe3RouteImport } from './routes/spotpris/elomrade-se3'
import { Route as SpotprisElomradeSe4RouteImport } from './routes/spotpris/elomrade-se4'
import { Route as SpotprisIdagRouteImport } from './routes/spotpris/idag'
import { Route as SpotprisImorgonRouteImport } from './routes/spotpris/imorgon'
import { Route as SpotprisSe1RouteImport } from './routes/spotpris/se1'
import { Route as SpotprisSe2RouteImport } from './routes/spotpris/se2'
import { Route as SpotprisSe3RouteImport } from './routes/spotpris/se3'
import { Route as SpotprisSe4RouteImport } from './routes/spotpris/se4'
import { Route as SpotpriserAreaRouteImport } from './routes/spotpriser/$area'
import { Route as VarmepumparIndexRouteImport } from './routes/varmepumpar/index'
import { Route as VarmepumparSlugRouteImport } from './routes/varmepumpar/$slug'
import { Route as VarmepumparOffertRouteImport } from './routes/varmepumpar/offert'
import { Route as VarmepumparVarmepumpskalkylatorRouteImport } from './routes/varmepumpar/varmepumpskalkylator'
import { Route as VerktygIndexRouteImport } from './routes/verktyg/index'
import { Route as VerktygHittaAnlaggningsIdRouteImport } from './routes/verktyg/hitta-anlaggnings-id'
import { Route as VerktygHittaElavtalRouteImport } from './routes/verktyg/hitta-elavtal'
import { Route as VerktygHittaElbolagRouteImport } from './routes/verktyg/hitta-elbolag'
import { Route as VerktygHittaElomradeRouteImport } from './routes/verktyg/hitta-elomrade'
import { Route as VerktygHittaNatagareRouteImport } from './routes/verktyg/hitta-natagare'
import { Route as VerktygMobilappRouteImport } from './routes/verktyg/mobilapp'
import { Route as AdminAiAssistentIndexRouteImport } from './routes/admin/ai-assistent.index'
import { Route as AdminAiAssistentThreadIdRouteImport } from './routes/admin/ai-assistent.$threadId'
import { Route as AdminArendenIndexRouteImport } from './routes/admin/arenden/index'
import { Route as AdminArendenTicketIdRouteImport } from './routes/admin/arenden/$ticketId'
import { Route as AdminArendenAutomatiskaSvarRouteImport } from './routes/admin/arenden/automatiska-svar'
import { Route as AdminArendenGranskningsloggRouteImport } from './routes/admin/arenden/granskningslogg'
import { Route as AdminArendenSignaturerRouteImport } from './routes/admin/arenden/signaturer'
import { Route as AdminArendenTestlageRouteImport } from './routes/admin/arenden/testlage'
import { Route as AdminIntegrationerGoogleWorkspaceRouteImport } from './routes/admin/integrationer/google-workspace'
import { Route as AdminKampanjCampaignIdRouteImport } from './routes/admin/kampanj.$campaignId'
import { Route as AdminLeadLeadIdRouteImport } from './routes/admin/lead.$leadId'
import { Route as AdminStatistikIndexRouteImport } from './routes/admin/statistik/index'
import { Route as AdminStatistikKanalerRouteImport } from './routes/admin/statistik/kanaler'
import { Route as AdminStatistikKlickRouteImport } from './routes/admin/statistik/klick'
import { Route as AdminStatistikScbRouteImport } from './routes/admin/statistik/scb'
import { Route as ElbolagElnatIndexRouteImport } from './routes/elbolag/elnat.index'
import { Route as ElbolagElnatSlugRouteImport } from './routes/elbolag/elnat.$slug'
import { Route as ElpriserHistorikIndexRouteImport } from './routes/elpriser/historik/index'
import { Route as HistoriskaElpriserManadMonthYearRouteImport } from './routes/historiska-elpriser/manad/$monthYear'
import { Route as ProdukterKategoriIndexRouteImport } from './routes/produkter/$kategori/index'
import { Route as ProdukterKategoriProduktRouteImport } from './routes/produkter/$kategori/$produkt'
import { Route as AdminStatistikKonverteringarIndexRouteImport } from './routes/admin/statistik/konverteringar/index'
import { Route as AdminStatistikKonverteringarGoalRouteImport } from './routes/admin/statistik/konverteringar/$goal'
import { Route as AdminStatistikScbKommunerRouteImport } from './routes/admin/statistik/scb_.kommuner'
import { Route as ElpriserHistorikYearSlugIndexRouteImport } from './routes/elpriser/historik/$yearSlug/index'
import { Route as ElpriserHistorikYearSlugMonthRouteImport } from './routes/elpriser/historik/$yearSlug/$month'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AiRoute = AiRouteImport.update({
            id: '/ai',path: '/ai',getParentRoute: () => rootRouteImport
          })
const AiFakturaanalysRoute = AiFakturaanalysRouteImport.update({
            id: '/ai-fakturaanalys',path: '/ai-fakturaanalys',getParentRoute: () => rootRouteImport
          })
const AiPrognoserRoute = AiPrognoserRouteImport.update({
            id: '/ai-prognoser',path: '/ai-prognoser',getParentRoute: () => rootRouteImport
          })
const AngerKlagomalRoute = AngerKlagomalRouteImport.update({
            id: '/anger-klagomal',path: '/anger-klagomal',getParentRoute: () => rootRouteImport
          })
const AnvandarvillkorRoute = AnvandarvillkorRouteImport.update({
            id: '/anvandarvillkor',path: '/anvandarvillkor',getParentRoute: () => rootRouteImport
          })
const AppIntegritetspolicyRoute = AppIntegritetspolicyRouteImport.update({
            id: '/app-integritetspolicy',path: '/app-integritetspolicy',getParentRoute: () => rootRouteImport
          })
const AppVillkorRoute = AppVillkorRouteImport.update({
            id: '/app-villkor',path: '/app-villkor',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BekraftaEpostRoute = BekraftaEpostRouteImport.update({
            id: '/bekrafta-epost',path: '/bekrafta-epost',getParentRoute: () => rootRouteImport
          })
const CompricerRoute = CompricerRouteImport.update({
            id: '/compricer',path: '/compricer',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const DagensElpriserRoute = DagensElpriserRouteImport.update({
            id: '/dagens-elpriser',path: '/dagens-elpriser',getParentRoute: () => rootRouteImport
          })
const DataskyddspolicyRoute = DataskyddspolicyRouteImport.update({
            id: '/dataskyddspolicy',path: '/dataskyddspolicy',getParentRoute: () => rootRouteImport
          })
const DiagramTabellerRoute = DiagramTabellerRouteImport.update({
            id: '/diagram-tabeller',path: '/diagram-tabeller',getParentRoute: () => rootRouteImport
          })
const ElbrukRoute = ElbrukRouteImport.update({
            id: '/elbruk',path: '/elbruk',getParentRoute: () => rootRouteImport
          })
const ElbyteRoute = ElbyteRouteImport.update({
            id: '/elbyte',path: '/elbyte',getParentRoute: () => rootRouteImport
          })
const ElmarknadAiRoute = ElmarknadAiRouteImport.update({
            id: '/elmarknad-ai',path: '/elmarknad-ai',getParentRoute: () => rootRouteImport
          })
const ElprisApiRoute = ElprisApiRouteImport.update({
            id: '/elpris-api',path: '/elpris-api',getParentRoute: () => rootRouteImport
          })
const ElpriskollenRoute = ElpriskollenRouteImport.update({
            id: '/elpriskollen',path: '/elpriskollen',getParentRoute: () => rootRouteImport
          })
const ElsklingRoute = ElsklingRouteImport.update({
            id: '/elskling',path: '/elskling',getParentRoute: () => rootRouteImport
          })
const FelanmalanRoute = FelanmalanRouteImport.update({
            id: '/felanmalan',path: '/felanmalan',getParentRoute: () => rootRouteImport
          })
const ForLlmsRoute = ForLlmsRouteImport.update({
            id: '/for-llms',path: '/for-llms',getParentRoute: () => rootRouteImport
          })
const ForfraganForetagBrfRoute = ForfraganForetagBrfRouteImport.update({
            id: '/forfragan-foretag-brf',path: '/forfragan-foretag-brf',getParentRoute: () => rootRouteImport
          })
const FragorSvarRoute = FragorSvarRouteImport.update({
            id: '/fragor-svar',path: '/fragor-svar',getParentRoute: () => rootRouteImport
          })
const HittaElbolagRoute = HittaElbolagRouteImport.update({
            id: '/hitta-elbolag',path: '/hitta-elbolag',getParentRoute: () => rootRouteImport
          })
const HittaElnatsomradeRoute = HittaElnatsomradeRouteImport.update({
            id: '/hitta-elnatsomrade',path: '/hitta-elnatsomrade',getParentRoute: () => rootRouteImport
          })
const HittaElomradeRoute = HittaElomradeRouteImport.update({
            id: '/hitta-elomrade',path: '/hitta-elomrade',getParentRoute: () => rootRouteImport
          })
const HittaNatagareRoute = HittaNatagareRouteImport.update({
            id: '/hitta-natagare',path: '/hitta-natagare',getParentRoute: () => rootRouteImport
          })
const JamforOffertRoute = JamforOffertRouteImport.update({
            id: '/jamfor-offert',path: '/jamfor-offert',getParentRoute: () => rootRouteImport
          })
const JobbaHosOssRoute = JobbaHosOssRouteImport.update({
            id: '/jobba-hos-oss',path: '/jobba-hos-oss',getParentRoute: () => rootRouteImport
          })
const KalkylatorerRoute = KalkylatorerRouteImport.update({
            id: '/kalkylatorer',path: '/kalkylatorer',getParentRoute: () => rootRouteImport
          })
const KassaRoute = KassaRouteImport.update({
            id: '/kassa',path: '/kassa',getParentRoute: () => rootRouteImport
          })
const KompletteraAnlaggningsidRoute = KompletteraAnlaggningsidRouteImport.update({
            id: '/komplettera-anlaggningsid',path: '/komplettera-anlaggningsid',getParentRoute: () => rootRouteImport
          })
const KompletteraAnlaggningsidTestRoute = KompletteraAnlaggningsidTestRouteImport.update({
            id: '/komplettera-anlaggningsid-test',path: '/komplettera-anlaggningsid-test',getParentRoute: () => rootRouteImport
          })
const KompletteraUppgifterRoute = KompletteraUppgifterRouteImport.update({
            id: '/komplettera-uppgifter',path: '/komplettera-uppgifter',getParentRoute: () => rootRouteImport
          })
const KompletteraUppgifterTestRoute = KompletteraUppgifterTestRouteImport.update({
            id: '/komplettera-uppgifter-test',path: '/komplettera-uppgifter-test',getParentRoute: () => rootRouteImport
          })
const KontaktRoute = KontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => rootRouteImport
          })
const LamnaFeedbackRoute = LamnaFeedbackRouteImport.update({
            id: '/lamna-feedback',path: '/lamna-feedback',getParentRoute: () => rootRouteImport
          })
const LamnaOmdomeRoute = LamnaOmdomeRouteImport.update({
            id: '/lamna-omdome',path: '/lamna-omdome',getParentRoute: () => rootRouteImport
          })
const LamnaSynpunktRoute = LamnaSynpunktRouteImport.update({
            id: '/lamna-synpunkt',path: '/lamna-synpunkt',getParentRoute: () => rootRouteImport
          })
const LoggaInRoute = LoggaInRouteImport.update({
            id: '/logga-in',path: '/logga-in',getParentRoute: () => rootRouteImport
          })
const MinaElpriserRoute = MinaElpriserRouteImport.update({
            id: '/mina-elpriser',path: '/mina-elpriser',getParentRoute: () => rootRouteImport
          })
const MinaSidorRoute = MinaSidorRouteImport.update({
            id: '/mina-sidor',path: '/mina-sidor',getParentRoute: () => rootRouteImport
          })
const MittAvtalRoute = MittAvtalRouteImport.update({
            id: '/mitt-avtal',path: '/mitt-avtal',getParentRoute: () => rootRouteImport
          })
const MittElprisRoute = MittElprisRouteImport.update({
            id: '/mitt-elpris',path: '/mitt-elpris',getParentRoute: () => rootRouteImport
          })
const MobilappRoute = MobilappRouteImport.update({
            id: '/mobilapp',path: '/mobilapp',getParentRoute: () => rootRouteImport
          })
const MorgondagensElpriserRoute = MorgondagensElpriserRouteImport.update({
            id: '/morgondagens-elpriser',path: '/morgondagens-elpriser',getParentRoute: () => rootRouteImport
          })
const OffertforfraganRoute = OffertforfraganRouteImport.update({
            id: '/offertforfragan',path: '/offertforfragan',getParentRoute: () => rootRouteImport
          })
const OmOssRoute = OmOssRouteImport.update({
            id: '/om-oss',path: '/om-oss',getParentRoute: () => rootRouteImport
          })
const PartnerRoute = PartnerRouteImport.update({
            id: '/partner',path: '/partner',getParentRoute: () => rootRouteImport
          })
const PartneransokanRoute = PartneransokanRouteImport.update({
            id: '/partneransokan',path: '/partneransokan',getParentRoute: () => rootRouteImport
          })
const PersonligEnergianalysRoute = PersonligEnergianalysRouteImport.update({
            id: '/personlig-energianalys',path: '/personlig-energianalys',getParentRoute: () => rootRouteImport
          })
const PressRoute = PressRouteImport.update({
            id: '/press',path: '/press',getParentRoute: () => rootRouteImport
          })
const ProduktionsstatusRoute = ProduktionsstatusRouteImport.update({
            id: '/produktionsstatus',path: '/produktionsstatus',getParentRoute: () => rootRouteImport
          })
const PrognosApiRoute = PrognosApiRouteImport.update({
            id: '/prognos-api',path: '/prognos-api',getParentRoute: () => rootRouteImport
          })
const SaveraRoute = SaveraRouteImport.update({
            id: '/savera',path: '/savera',getParentRoute: () => rootRouteImport
          })
const SkapaArendeRoute = SkapaArendeRouteImport.update({
            id: '/skapa-arende',path: '/skapa-arende',getParentRoute: () => rootRouteImport
          })
const SokRoute = SokRouteImport.update({
            id: '/sok',path: '/sok',getParentRoute: () => rootRouteImport
          })
const SokresultatRoute = SokresultatRouteImport.update({
            id: '/sokresultat',path: '/sokresultat',getParentRoute: () => rootRouteImport
          })
const SokresultatTestRoute = SokresultatTestRouteImport.update({
            id: '/sokresultat-test',path: '/sokresultat-test',getParentRoute: () => rootRouteImport
          })
const SolcellsofferterRoute = SolcellsofferterRouteImport.update({
            id: '/solcellsofferter',path: '/solcellsofferter',getParentRoute: () => rootRouteImport
          })
const SpontanansokanRoute = SpontanansokanRouteImport.update({
            id: '/spontanansokan',path: '/spontanansokan',getParentRoute: () => rootRouteImport
          })
const StartRoute = StartRouteImport.update({
            id: '/start',path: '/start',getParentRoute: () => rootRouteImport
          })
const TackForetagRoute = TackForetagRouteImport.update({
            id: '/tack-foretag',path: '/tack-foretag',getParentRoute: () => rootRouteImport
          })
const TackOffertRoute = TackOffertRouteImport.update({
            id: '/tack-offert',path: '/tack-offert',getParentRoute: () => rootRouteImport
          })
const ValjLosenordRoute = ValjLosenordRouteImport.update({
            id: '/valj-losenord',path: '/valj-losenord',getParentRoute: () => rootRouteImport
          })
const VerktygTjansterRoute = VerktygTjansterRouteImport.update({
            id: '/verktyg-tjanster',path: '/verktyg-tjanster',getParentRoute: () => rootRouteImport
          })
const VilketElbolagRoute = VilketElbolagRouteImport.update({
            id: '/vilket-elbolag',path: '/vilket-elbolag',getParentRoute: () => rootRouteImport
          })
const ZmartaRoute = ZmartaRouteImport.update({
            id: '/zmarta',path: '/zmarta',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminAdministratorerRoute = AdminAdministratorerRouteImport.update({
            id: '/administratorer',path: '/administratorer',getParentRoute: () => AdminRoute
          })
const AdminAiChattRoute = AdminAiChattRouteImport.update({
            id: '/ai-chatt',path: '/ai-chatt',getParentRoute: () => AdminRoute
          })
const AdminAnnonsorerRoute = AdminAnnonsorerRouteImport.update({
            id: '/annonsorer',path: '/annonsorer',getParentRoute: () => AdminRoute
          })
const AdminAnvandareRoute = AdminAnvandareRouteImport.update({
            id: '/anvandare',path: '/anvandare',getParentRoute: () => AdminRoute
          })
const AdminAvtalsApiRoute = AdminAvtalsApiRouteImport.update({
            id: '/avtals-api',path: '/avtals-api',getParentRoute: () => AdminRoute
          })
const AdminAvtalsbytenRoute = AdminAvtalsbytenRouteImport.update({
            id: '/avtalsbyten',path: '/avtalsbyten',getParentRoute: () => AdminRoute
          })
const AdminBetygRoute = AdminBetygRouteImport.update({
            id: '/betyg',path: '/betyg',getParentRoute: () => AdminRoute
          })
const AdminBildrapportRoute = AdminBildrapportRouteImport.update({
            id: '/bildrapport',path: '/bildrapport',getParentRoute: () => AdminRoute
          })
const AdminDokumentdataRoute = AdminDokumentdataRouteImport.update({
            id: '/dokumentdata',path: '/dokumentdata',getParentRoute: () => AdminRoute
          })
const AdminElavtalRoute = AdminElavtalRouteImport.update({
            id: '/elavtal',path: '/elavtal',getParentRoute: () => AdminRoute
          })
const AdminElhandelsbolagRoute = AdminElhandelsbolagRouteImport.update({
            id: '/elhandelsbolag',path: '/elhandelsbolag',getParentRoute: () => AdminRoute
          })
const AdminFullmakterRoute = AdminFullmakterRouteImport.update({
            id: '/fullmakter',path: '/fullmakter',getParentRoute: () => AdminRoute
          })
const AdminGodkannandenRoute = AdminGodkannandenRouteImport.update({
            id: '/godkannanden',path: '/godkannanden',getParentRoute: () => AdminRoute
          })
const AdminHistorikRoute = AdminHistorikRouteImport.update({
            id: '/historik',path: '/historik',getParentRoute: () => AdminRoute
          })
const AdminInnehallRoute = AdminInnehallRouteImport.update({
            id: '/innehall',path: '/innehall',getParentRoute: () => AdminRoute
          })
const AdminInstallningarRoute = AdminInstallningarRouteImport.update({
            id: '/installningar',path: '/installningar',getParentRoute: () => AdminRoute
          })
const AdminIntresseRoute = AdminIntresseRouteImport.update({
            id: '/intresse',path: '/intresse',getParentRoute: () => AdminRoute
          })
const AdminKampanjerRoute = AdminKampanjerRouteImport.update({
            id: '/kampanjer',path: '/kampanjer',getParentRoute: () => AdminRoute
          })
const AdminKunderRoute = AdminKunderRouteImport.update({
            id: '/kunder',path: '/kunder',getParentRoute: () => AdminRoute
          })
const AdminKundregisterRoute = AdminKundregisterRouteImport.update({
            id: '/kundregister',path: '/kundregister',getParentRoute: () => AdminRoute
          })
const AdminLaddstationerRoute = AdminLaddstationerRouteImport.update({
            id: '/laddstationer',path: '/laddstationer',getParentRoute: () => AdminRoute
          })
const AdminLeadpartnersRoute = AdminLeadpartnersRouteImport.update({
            id: '/leadpartners',path: '/leadpartners',getParentRoute: () => AdminRoute
          })
const AdminLeadsRoute = AdminLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => AdminRoute
          })
const AdminLogotyperRoute = AdminLogotyperRouteImport.update({
            id: '/logotyper',path: '/logotyper',getParentRoute: () => AdminRoute
          })
const AdminMailmallarRoute = AdminMailmallarRouteImport.update({
            id: '/mailmallar',path: '/mailmallar',getParentRoute: () => AdminRoute
          })
const AdminMejlgranskningRoute = AdminMejlgranskningRouteImport.update({
            id: '/mejlgranskning',path: '/mejlgranskning',getParentRoute: () => AdminRoute
          })
const AdminMinaSidorRoute = AdminMinaSidorRouteImport.update({
            id: '/mina-sidor',path: '/mina-sidor',getParentRoute: () => AdminRoute
          })
const AdminNyheterRoute = AdminNyheterRouteImport.update({
            id: '/nyheter',path: '/nyheter',getParentRoute: () => AdminRoute
          })
const AdminNyhetsbrevRoute = AdminNyhetsbrevRouteImport.update({
            id: '/nyhetsbrev',path: '/nyhetsbrev',getParentRoute: () => AdminRoute
          })
const AdminOmdirigeringarRoute = AdminOmdirigeringarRouteImport.update({
            id: '/omdirigeringar',path: '/omdirigeringar',getParentRoute: () => AdminRoute
          })
const AdminPrisfilerRoute = AdminPrisfilerRouteImport.update({
            id: '/prisfiler',path: '/prisfiler',getParentRoute: () => AdminRoute
          })
const AdminProdukterRoute = AdminProdukterRouteImport.update({
            id: '/produkter',path: '/produkter',getParentRoute: () => AdminRoute
          })
const AdminPrognosApiRoute = AdminPrognosApiRouteImport.update({
            id: '/prognos-api',path: '/prognos-api',getParentRoute: () => AdminRoute
          })
const AdminRapporterRoute = AdminRapporterRouteImport.update({
            id: '/rapporter',path: '/rapporter',getParentRoute: () => AdminRoute
          })
const AdminRapportfilerRoute = AdminRapportfilerRouteImport.update({
            id: '/rapportfiler',path: '/rapportfiler',getParentRoute: () => AdminRoute
          })
const AdminReturerRoute = AdminReturerRouteImport.update({
            id: '/returer',path: '/returer',getParentRoute: () => AdminRoute
          })
const AdminSeoRoute = AdminSeoRouteImport.update({
            id: '/seo',path: '/seo',getParentRoute: () => AdminRoute
          })
const AdminSocialaMedierRoute = AdminSocialaMedierRouteImport.update({
            id: '/sociala-medier',path: '/sociala-medier',getParentRoute: () => AdminRoute
          })
const AdminSokinsikterRoute = AdminSokinsikterRouteImport.update({
            id: '/sokinsikter',path: '/sokinsikter',getParentRoute: () => AdminRoute
          })
const AdminSokresultatRoute = AdminSokresultatRouteImport.update({
            id: '/sokresultat',path: '/sokresultat',getParentRoute: () => AdminRoute
          })
const AdminSpotpriserRoute = AdminSpotpriserRouteImport.update({
            id: '/spotpriser',path: '/spotpriser',getParentRoute: () => AdminRoute
          })
const AdminTrenderRoute = AdminTrenderRouteImport.update({
            id: '/trender',path: '/trender',getParentRoute: () => AdminRoute
          })
const AdminVerktygRoute = AdminVerktygRouteImport.update({
            id: '/verktyg',path: '/verktyg',getParentRoute: () => AdminRoute
          })
const BatterierIndexRoute = BatterierIndexRouteImport.update({
            id: '/batterier/',path: '/batterier/',getParentRoute: () => rootRouteImport
          })
const BatterierSlugRoute = BatterierSlugRouteImport.update({
            id: '/batterier/$slug',path: '/batterier/$slug',getParentRoute: () => rootRouteImport
          })
const BatterierBatterikalkylatorRoute = BatterierBatterikalkylatorRouteImport.update({
            id: '/batterier/batterikalkylator',path: '/batterier/batterikalkylator',getParentRoute: () => rootRouteImport
          })
const BatterierOffertRoute = BatterierOffertRouteImport.update({
            id: '/batterier/offert',path: '/batterier/offert',getParentRoute: () => rootRouteImport
          })
const BliPartnerIndexRoute = BliPartnerIndexRouteImport.update({
            id: '/bli-partner/',path: '/bli-partner/',getParentRoute: () => rootRouteImport
          })
const BliPartnerSlugRoute = BliPartnerSlugRouteImport.update({
            id: '/bli-partner/$slug',path: '/bli-partner/$slug',getParentRoute: () => rootRouteImport
          })
const BloggIndexRoute = BloggIndexRouteImport.update({
            id: '/blogg/',path: '/blogg/',getParentRoute: () => rootRouteImport
          })
const BloggSlugRoute = BloggSlugRouteImport.update({
            id: '/blogg/$slug',path: '/blogg/$slug',getParentRoute: () => rootRouteImport
          })
const DagensSpotprisIndexRoute = DagensSpotprisIndexRouteImport.update({
            id: '/dagens-spotpris/',path: '/dagens-spotpris/',getParentRoute: () => rootRouteImport
          })
const DagensSpotprisSlugRoute = DagensSpotprisSlugRouteImport.update({
            id: '/dagens-spotpris/$slug',path: '/dagens-spotpris/$slug',getParentRoute: () => rootRouteImport
          })
const ElavtalIndexRoute = ElavtalIndexRouteImport.update({
            id: '/elavtal/',path: '/elavtal/',getParentRoute: () => rootRouteImport
          })
const ElavtalSlugRoute = ElavtalSlugRouteImport.update({
            id: '/elavtal/$slug',path: '/elavtal/$slug',getParentRoute: () => rootRouteImport
          })
const ElavtalAnvisatRoute = ElavtalAnvisatRouteImport.update({
            id: '/elavtal/anvisat',path: '/elavtal/anvisat',getParentRoute: () => rootRouteImport
          })
const ElavtalAvtalsvaljarenRoute = ElavtalAvtalsvaljarenRouteImport.update({
            id: '/elavtal/avtalsvaljaren',path: '/elavtal/avtalsvaljaren',getParentRoute: () => rootRouteImport
          })
const ElavtalBastaRoute = ElavtalBastaRouteImport.update({
            id: '/elavtal/basta',path: '/elavtal/basta',getParentRoute: () => rootRouteImport
          })
const ElavtalBestallRoute = ElavtalBestallRouteImport.update({
            id: '/elavtal/bestall',path: '/elavtal/bestall',getParentRoute: () => rootRouteImport
          })
const ElavtalBilligaRoute = ElavtalBilligaRouteImport.update({
            id: '/elavtal/billiga',path: '/elavtal/billiga',getParentRoute: () => rootRouteImport
          })
const ElavtalBindaRoute = ElavtalBindaRouteImport.update({
            id: '/elavtal/binda',path: '/elavtal/binda',getParentRoute: () => rootRouteImport
          })
const ElavtalBlackFridayRoute = ElavtalBlackFridayRouteImport.update({
            id: '/elavtal/black-friday',path: '/elavtal/black-friday',getParentRoute: () => rootRouteImport
          })
const ElavtalBrfRoute = ElavtalBrfRouteImport.update({
            id: '/elavtal/brf',path: '/elavtal/brf',getParentRoute: () => rootRouteImport
          })
const ElavtalBytRoute = ElavtalBytRouteImport.update({
            id: '/elavtal/byt',path: '/elavtal/byt',getParentRoute: () => rootRouteImport
          })
const ElavtalFastRoute = ElavtalFastRouteImport.update({
            id: '/elavtal/fast',path: '/elavtal/fast',getParentRoute: () => rootRouteImport
          })
const ElavtalForetagRoute = ElavtalForetagRouteImport.update({
            id: '/elavtal/foretag',path: '/elavtal/foretag',getParentRoute: () => rootRouteImport
          })
const ElavtalForstaGangenRoute = ElavtalForstaGangenRouteImport.update({
            id: '/elavtal/forsta-gangen',path: '/elavtal/forsta-gangen',getParentRoute: () => rootRouteImport
          })
const ElavtalFritidshusRoute = ElavtalFritidshusRouteImport.update({
            id: '/elavtal/fritidshus',path: '/elavtal/fritidshus',getParentRoute: () => rootRouteImport
          })
const ElavtalJamforRoute = ElavtalJamforRouteImport.update({
            id: '/elavtal/jamfor',path: '/elavtal/jamfor',getParentRoute: () => rootRouteImport
          })
const ElavtalJamforTestRoute = ElavtalJamforTestRouteImport.update({
            id: '/elavtal/jamfor-test',path: '/elavtal/jamfor-test',getParentRoute: () => rootRouteImport
          })
const ElavtalKvartsprisRoute = ElavtalKvartsprisRouteImport.update({
            id: '/elavtal/kvartspris',path: '/elavtal/kvartspris',getParentRoute: () => rootRouteImport
          })
const ElavtalLagenhetRoute = ElavtalLagenhetRouteImport.update({
            id: '/elavtal/lagenhet',path: '/elavtal/lagenhet',getParentRoute: () => rootRouteImport
          })
const ElavtalManadsprisRoute = ElavtalManadsprisRouteImport.update({
            id: '/elavtal/manadspris',path: '/elavtal/manadspris',getParentRoute: () => rootRouteImport
          })
const ElavtalMixprisRoute = ElavtalMixprisRouteImport.update({
            id: '/elavtal/mixpris',path: '/elavtal/mixpris',getParentRoute: () => rootRouteImport
          })
const ElavtalPensionarRoute = ElavtalPensionarRouteImport.update({
            id: '/elavtal/pensionar',path: '/elavtal/pensionar',getParentRoute: () => rootRouteImport
          })
const ElavtalPensionarerRoute = ElavtalPensionarerRouteImport.update({
            id: '/elavtal/pensionarer',path: '/elavtal/pensionarer',getParentRoute: () => rootRouteImport
          })
const ElavtalPortfoljRoute = ElavtalPortfoljRouteImport.update({
            id: '/elavtal/portfolj',path: '/elavtal/portfolj',getParentRoute: () => rootRouteImport
          })
const ElavtalRorligtRoute = ElavtalRorligtRouteImport.update({
            id: '/elavtal/rorligt',path: '/elavtal/rorligt',getParentRoute: () => rootRouteImport
          })
const ElavtalSagUppRoute = ElavtalSagUppRouteImport.update({
            id: '/elavtal/sag-upp',path: '/elavtal/sag-upp',getParentRoute: () => rootRouteImport
          })
const ElavtalStudentRoute = ElavtalStudentRouteImport.update({
            id: '/elavtal/student',path: '/elavtal/student',getParentRoute: () => rootRouteImport
          })
const ElavtalStudenterRoute = ElavtalStudenterRouteImport.update({
            id: '/elavtal/studenter',path: '/elavtal/studenter',getParentRoute: () => rootRouteImport
          })
const ElavtalTecknaRoute = ElavtalTecknaRouteImport.update({
            id: '/elavtal/teckna',path: '/elavtal/teckna',getParentRoute: () => rootRouteImport
          })
const ElavtalTillsvidareRoute = ElavtalTillsvidareRouteImport.update({
            id: '/elavtal/tillsvidare',path: '/elavtal/tillsvidare',getParentRoute: () => rootRouteImport
          })
const ElavtalTimprisRoute = ElavtalTimprisRouteImport.update({
            id: '/elavtal/timpris',path: '/elavtal/timpris',getParentRoute: () => rootRouteImport
          })
const ElavtalVidFlyttRoute = ElavtalVidFlyttRouteImport.update({
            id: '/elavtal/vid-flytt',path: '/elavtal/vid-flytt',getParentRoute: () => rootRouteImport
          })
const ElavtalVillaRoute = ElavtalVillaRouteImport.update({
            id: '/elavtal/villa',path: '/elavtal/villa',getParentRoute: () => rootRouteImport
          })
const ElavtalVintersakratRoute = ElavtalVintersakratRouteImport.update({
            id: '/elavtal/vintersakrat',path: '/elavtal/vintersakrat',getParentRoute: () => rootRouteImport
          })
const ElbolagIndexRoute = ElbolagIndexRouteImport.update({
            id: '/elbolag/',path: '/elbolag/',getParentRoute: () => rootRouteImport
          })
const ElbolagSlugRoute = ElbolagSlugRouteImport.update({
            id: '/elbolag/$slug',path: '/elbolag/$slug',getParentRoute: () => rootRouteImport
          })
const ElbolagBastaRoute = ElbolagBastaRouteImport.update({
            id: '/elbolag/basta',path: '/elbolag/basta',getParentRoute: () => rootRouteImport
          })
const ElbolagBilligasteRoute = ElbolagBilligasteRouteImport.update({
            id: '/elbolag/billigaste',path: '/elbolag/billigaste',getParentRoute: () => rootRouteImport
          })
const ElbolagBytRoute = ElbolagBytRouteImport.update({
            id: '/elbolag/byt',path: '/elbolag/byt',getParentRoute: () => rootRouteImport
          })
const ElbolagElhandelRoute = ElbolagElhandelRouteImport.update({
            id: '/elbolag/elhandel',path: '/elbolag/elhandel',getParentRoute: () => rootRouteImport
          })
const ElbolagElnatRoute = ElbolagElnatRouteImport.update({
            id: '/elbolag/elnat',path: '/elbolag/elnat',getParentRoute: () => rootRouteImport
          })
const ElbolagJamforRoute = ElbolagJamforRouteImport.update({
            id: '/elbolag/jamfor',path: '/elbolag/jamfor',getParentRoute: () => rootRouteImport
          })
const ElhandelIndexRoute = ElhandelIndexRouteImport.update({
            id: '/elhandel/',path: '/elhandel/',getParentRoute: () => rootRouteImport
          })
const ElhandelSlugRoute = ElhandelSlugRouteImport.update({
            id: '/elhandel/$slug',path: '/elhandel/$slug',getParentRoute: () => rootRouteImport
          })
const ElmarknadenIndexRoute = ElmarknadenIndexRouteImport.update({
            id: '/elmarknaden/',path: '/elmarknaden/',getParentRoute: () => rootRouteImport
          })
const ElmarknadenAvregleringenRoute = ElmarknadenAvregleringenRouteImport.update({
            id: '/elmarknaden/avregleringen',path: '/elmarknaden/avregleringen',getParentRoute: () => rootRouteImport
          })
const ElmarknadenFramtidenRoute = ElmarknadenFramtidenRouteImport.update({
            id: '/elmarknaden/framtiden',path: '/elmarknaden/framtiden',getParentRoute: () => rootRouteImport
          })
const ElmarknadenHistoriaRoute = ElmarknadenHistoriaRouteImport.update({
            id: '/elmarknaden/historia',path: '/elmarknaden/historia',getParentRoute: () => rootRouteImport
          })
const ElmarknadenSaFungerarElmarknadenRoute = ElmarknadenSaFungerarElmarknadenRouteImport.update({
            id: '/elmarknaden/sa-fungerar-elmarknaden',path: '/elmarknaden/sa-fungerar-elmarknaden',getParentRoute: () => rootRouteImport
          })
const ElnatIndexRoute = ElnatIndexRouteImport.update({
            id: '/elnat/',path: '/elnat/',getParentRoute: () => rootRouteImport
          })
const ElnatSlugRoute = ElnatSlugRouteImport.update({
            id: '/elnat/$slug',path: '/elnat/$slug',getParentRoute: () => rootRouteImport
          })
const ElpriserIndexRoute = ElpriserIndexRouteImport.update({
            id: '/elpriser/',path: '/elpriser/',getParentRoute: () => rootRouteImport
          })
const ElpriserSlugRoute = ElpriserSlugRouteImport.update({
            id: '/elpriser/$slug',path: '/elpriser/$slug',getParentRoute: () => rootRouteImport
          })
const ElpriserElomrade1Route = ElpriserElomrade1RouteImport.update({
            id: '/elpriser/elomrade-1',path: '/elpriser/elomrade-1',getParentRoute: () => rootRouteImport
          })
const ElpriserElomrade2Route = ElpriserElomrade2RouteImport.update({
            id: '/elpriser/elomrade-2',path: '/elpriser/elomrade-2',getParentRoute: () => rootRouteImport
          })
const ElpriserElomrade3Route = ElpriserElomrade3RouteImport.update({
            id: '/elpriser/elomrade-3',path: '/elpriser/elomrade-3',getParentRoute: () => rootRouteImport
          })
const ElpriserElomrade4Route = ElpriserElomrade4RouteImport.update({
            id: '/elpriser/elomrade-4',path: '/elpriser/elomrade-4',getParentRoute: () => rootRouteImport
          })
const ElpriserFastRoute = ElpriserFastRouteImport.update({
            id: '/elpriser/fast',path: '/elpriser/fast',getParentRoute: () => rootRouteImport
          })
const ElpriserIdagRoute = ElpriserIdagRouteImport.update({
            id: '/elpriser/idag',path: '/elpriser/idag',getParentRoute: () => rootRouteImport
          })
const ElpriserImorgonRoute = ElpriserImorgonRouteImport.update({
            id: '/elpriser/imorgon',path: '/elpriser/imorgon',getParentRoute: () => rootRouteImport
          })
const ElpriserJamforRoute = ElpriserJamforRouteImport.update({
            id: '/elpriser/jamfor',path: '/elpriser/jamfor',getParentRoute: () => rootRouteImport
          })
const ElpriserKvartsprisRoute = ElpriserKvartsprisRouteImport.update({
            id: '/elpriser/kvartspris',path: '/elpriser/kvartspris',getParentRoute: () => rootRouteImport
          })
const ElpriserManadsprisRoute = ElpriserManadsprisRouteImport.update({
            id: '/elpriser/manadspris',path: '/elpriser/manadspris',getParentRoute: () => rootRouteImport
          })
const ElpriserNordpoolRoute = ElpriserNordpoolRouteImport.update({
            id: '/elpriser/nordpool',path: '/elpriser/nordpool',getParentRoute: () => rootRouteImport
          })
const ElpriserPrognosRoute = ElpriserPrognosRouteImport.update({
            id: '/elpriser/prognos',path: '/elpriser/prognos',getParentRoute: () => rootRouteImport
          })
const ElpriserRorligtRoute = ElpriserRorligtRouteImport.update({
            id: '/elpriser/rorligt',path: '/elpriser/rorligt',getParentRoute: () => rootRouteImport
          })
const ElpriserSe1Route = ElpriserSe1RouteImport.update({
            id: '/elpriser/se1',path: '/elpriser/se1',getParentRoute: () => rootRouteImport
          })
const ElpriserSe2Route = ElpriserSe2RouteImport.update({
            id: '/elpriser/se2',path: '/elpriser/se2',getParentRoute: () => rootRouteImport
          })
const ElpriserSe3Route = ElpriserSe3RouteImport.update({
            id: '/elpriser/se3',path: '/elpriser/se3',getParentRoute: () => rootRouteImport
          })
const ElpriserSe4Route = ElpriserSe4RouteImport.update({
            id: '/elpriser/se4',path: '/elpriser/se4',getParentRoute: () => rootRouteImport
          })
const ElpriserTimprisRoute = ElpriserTimprisRouteImport.update({
            id: '/elpriser/timpris',path: '/elpriser/timpris',getParentRoute: () => rootRouteImport
          })
const HembatterierSlugRoute = HembatterierSlugRouteImport.update({
            id: '/hembatterier/$slug',path: '/hembatterier/$slug',getParentRoute: () => rootRouteImport
          })
const HembatterierOffertRoute = HembatterierOffertRouteImport.update({
            id: '/hembatterier/offert',path: '/hembatterier/offert',getParentRoute: () => rootRouteImport
          })
const HistoriskaElpriserIndexRoute = HistoriskaElpriserIndexRouteImport.update({
            id: '/historiska-elpriser/',path: '/historiska-elpriser/',getParentRoute: () => rootRouteImport
          })
const HistoriskaElpriserRestRoute = HistoriskaElpriserRestRouteImport.update({
            id: '/historiska-elpriser/$rest',path: '/historiska-elpriser/$rest',getParentRoute: () => rootRouteImport
          })
const JamforOfferterIndexRoute = JamforOfferterIndexRouteImport.update({
            id: '/jamfor-offerter/',path: '/jamfor-offerter/',getParentRoute: () => rootRouteImport
          })
const JamforOfferterSlugRoute = JamforOfferterSlugRouteImport.update({
            id: '/jamfor-offerter/$slug',path: '/jamfor-offerter/$slug',getParentRoute: () => rootRouteImport
          })
const KommersiellaBatterierIndexRoute = KommersiellaBatterierIndexRouteImport.update({
            id: '/kommersiella-batterier/',path: '/kommersiella-batterier/',getParentRoute: () => rootRouteImport
          })
const KommersiellaBatterierSlugRoute = KommersiellaBatterierSlugRouteImport.update({
            id: '/kommersiella-batterier/$slug',path: '/kommersiella-batterier/$slug',getParentRoute: () => rootRouteImport
          })
const KommersiellaBatterierOffertRoute = KommersiellaBatterierOffertRouteImport.update({
            id: '/kommersiella-batterier/offert',path: '/kommersiella-batterier/offert',getParentRoute: () => rootRouteImport
          })
const KommersiellaSolcellerIndexRoute = KommersiellaSolcellerIndexRouteImport.update({
            id: '/kommersiella-solceller/',path: '/kommersiella-solceller/',getParentRoute: () => rootRouteImport
          })
const KommersiellaSolcellerSlugRoute = KommersiellaSolcellerSlugRouteImport.update({
            id: '/kommersiella-solceller/$slug',path: '/kommersiella-solceller/$slug',getParentRoute: () => rootRouteImport
          })
const KommersiellaSolcellerOffertRoute = KommersiellaSolcellerOffertRouteImport.update({
            id: '/kommersiella-solceller/offert',path: '/kommersiella-solceller/offert',getParentRoute: () => rootRouteImport
          })
const KommunIndexRoute = KommunIndexRouteImport.update({
            id: '/kommun/',path: '/kommun/',getParentRoute: () => rootRouteImport
          })
const KommunSlugRoute = KommunSlugRouteImport.update({
            id: '/kommun/$slug',path: '/kommun/$slug',getParentRoute: () => rootRouteImport
          })
const LaddboxarIndexRoute = LaddboxarIndexRouteImport.update({
            id: '/laddboxar/',path: '/laddboxar/',getParentRoute: () => rootRouteImport
          })
const LaddboxarSlugRoute = LaddboxarSlugRouteImport.update({
            id: '/laddboxar/$slug',path: '/laddboxar/$slug',getParentRoute: () => rootRouteImport
          })
const LaddboxarLaddboxkalkylatorRoute = LaddboxarLaddboxkalkylatorRouteImport.update({
            id: '/laddboxar/laddboxkalkylator',path: '/laddboxar/laddboxkalkylator',getParentRoute: () => rootRouteImport
          })
const LaddboxarOffertRoute = LaddboxarOffertRouteImport.update({
            id: '/laddboxar/offert',path: '/laddboxar/offert',getParentRoute: () => rootRouteImport
          })
const LaddstationerIndexRoute = LaddstationerIndexRouteImport.update({
            id: '/laddstationer/',path: '/laddstationer/',getParentRoute: () => rootRouteImport
          })
const LaddstationerSlugRoute = LaddstationerSlugRouteImport.update({
            id: '/laddstationer/$slug',path: '/laddstationer/$slug',getParentRoute: () => rootRouteImport
          })
const LaddstolparIndexRoute = LaddstolparIndexRouteImport.update({
            id: '/laddstolpar/',path: '/laddstolpar/',getParentRoute: () => rootRouteImport
          })
const LaddstolparSlugRoute = LaddstolparSlugRouteImport.update({
            id: '/laddstolpar/$slug',path: '/laddstolpar/$slug',getParentRoute: () => rootRouteImport
          })
const LaddstolparOffertRoute = LaddstolparOffertRouteImport.update({
            id: '/laddstolpar/offert',path: '/laddstolpar/offert',getParentRoute: () => rootRouteImport
          })
const MinaSidorIndexRoute = MinaSidorIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MinaSidorRoute
          })
const MinaSidorAnalyserRoute = MinaSidorAnalyserRouteImport.update({
            id: '/analyser',path: '/analyser',getParentRoute: () => MinaSidorRoute
          })
const MinaSidorAnlaggningarRoute = MinaSidorAnlaggningarRouteImport.update({
            id: '/anlaggningar',path: '/anlaggningar',getParentRoute: () => MinaSidorRoute
          })
const MinaSidorAvtalsforfragningarRoute = MinaSidorAvtalsforfragningarRouteImport.update({
            id: '/avtalsforfragningar',path: '/avtalsforfragningar',getParentRoute: () => MinaSidorRoute
          })
const MinaSidorElavtalRoute = MinaSidorElavtalRouteImport.update({
            id: '/elavtal',path: '/elavtal',getParentRoute: () => MinaSidorRoute
          })
const MinaSidorFaktureringRoute = MinaSidorFaktureringRouteImport.update({
            id: '/fakturering',path: '/fakturering',getParentRoute: () => MinaSidorRoute
          })
const MinaSidorFakturorRoute = MinaSidorFakturorRouteImport.update({
            id: '/fakturor',path: '/fakturor',getParentRoute: () => MinaSidorRoute
          })
const MinaSidorForbrukningRoute = MinaSidorForbrukningRouteImport.update({
            id: '/forbrukning',path: '/forbrukning',getParentRoute: () => MinaSidorRoute
          })
const MinaSidorForfragningarRoute = MinaSidorForfragningarRouteImport.update({
            id: '/forfragningar',path: '/forfragningar',getParentRoute: () => MinaSidorRoute
          })
const MinaSidorFullmakterRoute = MinaSidorFullmakterRouteImport.update({
            id: '/fullmakter',path: '/fullmakter',getParentRoute: () => MinaSidorRoute
          })
const MinaSidorInstallningarRoute = MinaSidorInstallningarRouteImport.update({
            id: '/installningar',path: '/installningar',getParentRoute: () => MinaSidorRoute
          })
const MinaSidorKontoinstallningarRoute = MinaSidorKontoinstallningarRouteImport.update({
            id: '/kontoinstallningar',path: '/kontoinstallningar',getParentRoute: () => MinaSidorRoute
          })
const MinaSidorNotiserRoute = MinaSidorNotiserRouteImport.update({
            id: '/notiser',path: '/notiser',getParentRoute: () => MinaSidorRoute
          })
const MinaSidorOffertforfragningarRoute = MinaSidorOffertforfragningarRouteImport.update({
            id: '/offertforfragningar',path: '/offertforfragningar',getParentRoute: () => MinaSidorRoute
          })
const MinaSidorProfilRoute = MinaSidorProfilRouteImport.update({
            id: '/profil',path: '/profil',getParentRoute: () => MinaSidorRoute
          })
const MinaSidorRapporterRoute = MinaSidorRapporterRouteImport.update({
            id: '/rapporter',path: '/rapporter',getParentRoute: () => MinaSidorRoute
          })
const MinaSidorVerktygRoute = MinaSidorVerktygRouteImport.update({
            id: '/verktyg',path: '/verktyg',getParentRoute: () => MinaSidorRoute
          })
const NyheterIndexRoute = NyheterIndexRouteImport.update({
            id: '/nyheter/',path: '/nyheter/',getParentRoute: () => rootRouteImport
          })
const NyheterSlugRoute = NyheterSlugRouteImport.update({
            id: '/nyheter/$slug',path: '/nyheter/$slug',getParentRoute: () => rootRouteImport
          })
const OfferterIndexRoute = OfferterIndexRouteImport.update({
            id: '/offerter/',path: '/offerter/',getParentRoute: () => rootRouteImport
          })
const OrdlistaIndexRoute = OrdlistaIndexRouteImport.update({
            id: '/ordlista/',path: '/ordlista/',getParentRoute: () => rootRouteImport
          })
const OrdlistaTermRoute = OrdlistaTermRouteImport.update({
            id: '/ordlista/$term',path: '/ordlista/$term',getParentRoute: () => rootRouteImport
          })
const PartnerIndexRoute = PartnerIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PartnerRoute
          })
const PartnerFaktureringRoute = PartnerFaktureringRouteImport.update({
            id: '/fakturering',path: '/fakturering',getParentRoute: () => PartnerRoute
          })
const PartnerImportRoute = PartnerImportRouteImport.update({
            id: '/import',path: '/import',getParentRoute: () => PartnerRoute
          })
const PartnerKampanjerRoute = PartnerKampanjerRouteImport.update({
            id: '/kampanjer',path: '/kampanjer',getParentRoute: () => PartnerRoute
          })
const PartnerLeadsRoute = PartnerLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => PartnerRoute
          })
const PartnerProfilRoute = PartnerProfilRouteImport.update({
            id: '/profil',path: '/profil',getParentRoute: () => PartnerRoute
          })
const PressreleaserIndexRoute = PressreleaserIndexRouteImport.update({
            id: '/pressreleaser/',path: '/pressreleaser/',getParentRoute: () => rootRouteImport
          })
const PressreleaserSlugRoute = PressreleaserSlugRouteImport.update({
            id: '/pressreleaser/$slug',path: '/pressreleaser/$slug',getParentRoute: () => rootRouteImport
          })
const ProdukterIndexRoute = ProdukterIndexRouteImport.update({
            id: '/produkter/',path: '/produkter/',getParentRoute: () => rootRouteImport
          })
const RapporterIndexRoute = RapporterIndexRouteImport.update({
            id: '/rapporter/',path: '/rapporter/',getParentRoute: () => rootRouteImport
          })
const RapporterSlugRoute = RapporterSlugRouteImport.update({
            id: '/rapporter/$slug',path: '/rapporter/$slug',getParentRoute: () => rootRouteImport
          })
const RapporterElprisetISverigeRoute = RapporterElprisetISverigeRouteImport.update({
            id: '/rapporter/elpriset-i-sverige',path: '/rapporter/elpriset-i-sverige',getParentRoute: () => rootRouteImport
          })
const SolcellerIndexRoute = SolcellerIndexRouteImport.update({
            id: '/solceller/',path: '/solceller/',getParentRoute: () => rootRouteImport
          })
const SolcellerSlugRoute = SolcellerSlugRouteImport.update({
            id: '/solceller/$slug',path: '/solceller/$slug',getParentRoute: () => rootRouteImport
          })
const SolcellerOffertRoute = SolcellerOffertRouteImport.update({
            id: '/solceller/offert',path: '/solceller/offert',getParentRoute: () => rootRouteImport
          })
const SolcellerSolcellskalkylatorRoute = SolcellerSolcellskalkylatorRouteImport.update({
            id: '/solceller/solcellskalkylator',path: '/solceller/solcellskalkylator',getParentRoute: () => rootRouteImport
          })
const SpotprisIndexRoute = SpotprisIndexRouteImport.update({
            id: '/spotpris/',path: '/spotpris/',getParentRoute: () => rootRouteImport
          })
const SpotprisSlugRoute = SpotprisSlugRouteImport.update({
            id: '/spotpris/$slug',path: '/spotpris/$slug',getParentRoute: () => rootRouteImport
          })
const SpotprisElomradeSe1Route = SpotprisElomradeSe1RouteImport.update({
            id: '/spotpris/elomrade-se1',path: '/spotpris/elomrade-se1',getParentRoute: () => rootRouteImport
          })
const SpotprisElomradeSe2Route = SpotprisElomradeSe2RouteImport.update({
            id: '/spotpris/elomrade-se2',path: '/spotpris/elomrade-se2',getParentRoute: () => rootRouteImport
          })
const SpotprisElomradeSe3Route = SpotprisElomradeSe3RouteImport.update({
            id: '/spotpris/elomrade-se3',path: '/spotpris/elomrade-se3',getParentRoute: () => rootRouteImport
          })
const SpotprisElomradeSe4Route = SpotprisElomradeSe4RouteImport.update({
            id: '/spotpris/elomrade-se4',path: '/spotpris/elomrade-se4',getParentRoute: () => rootRouteImport
          })
const SpotprisIdagRoute = SpotprisIdagRouteImport.update({
            id: '/spotpris/idag',path: '/spotpris/idag',getParentRoute: () => rootRouteImport
          })
const SpotprisImorgonRoute = SpotprisImorgonRouteImport.update({
            id: '/spotpris/imorgon',path: '/spotpris/imorgon',getParentRoute: () => rootRouteImport
          })
const SpotprisSe1Route = SpotprisSe1RouteImport.update({
            id: '/spotpris/se1',path: '/spotpris/se1',getParentRoute: () => rootRouteImport
          })
const SpotprisSe2Route = SpotprisSe2RouteImport.update({
            id: '/spotpris/se2',path: '/spotpris/se2',getParentRoute: () => rootRouteImport
          })
const SpotprisSe3Route = SpotprisSe3RouteImport.update({
            id: '/spotpris/se3',path: '/spotpris/se3',getParentRoute: () => rootRouteImport
          })
const SpotprisSe4Route = SpotprisSe4RouteImport.update({
            id: '/spotpris/se4',path: '/spotpris/se4',getParentRoute: () => rootRouteImport
          })
const SpotpriserAreaRoute = SpotpriserAreaRouteImport.update({
            id: '/spotpriser/$area',path: '/spotpriser/$area',getParentRoute: () => rootRouteImport
          })
const VarmepumparIndexRoute = VarmepumparIndexRouteImport.update({
            id: '/varmepumpar/',path: '/varmepumpar/',getParentRoute: () => rootRouteImport
          })
const VarmepumparSlugRoute = VarmepumparSlugRouteImport.update({
            id: '/varmepumpar/$slug',path: '/varmepumpar/$slug',getParentRoute: () => rootRouteImport
          })
const VarmepumparOffertRoute = VarmepumparOffertRouteImport.update({
            id: '/varmepumpar/offert',path: '/varmepumpar/offert',getParentRoute: () => rootRouteImport
          })
const VarmepumparVarmepumpskalkylatorRoute = VarmepumparVarmepumpskalkylatorRouteImport.update({
            id: '/varmepumpar/varmepumpskalkylator',path: '/varmepumpar/varmepumpskalkylator',getParentRoute: () => rootRouteImport
          })
const VerktygIndexRoute = VerktygIndexRouteImport.update({
            id: '/verktyg/',path: '/verktyg/',getParentRoute: () => rootRouteImport
          })
const VerktygHittaAnlaggningsIdRoute = VerktygHittaAnlaggningsIdRouteImport.update({
            id: '/verktyg/hitta-anlaggnings-id',path: '/verktyg/hitta-anlaggnings-id',getParentRoute: () => rootRouteImport
          })
const VerktygHittaElavtalRoute = VerktygHittaElavtalRouteImport.update({
            id: '/verktyg/hitta-elavtal',path: '/verktyg/hitta-elavtal',getParentRoute: () => rootRouteImport
          })
const VerktygHittaElbolagRoute = VerktygHittaElbolagRouteImport.update({
            id: '/verktyg/hitta-elbolag',path: '/verktyg/hitta-elbolag',getParentRoute: () => rootRouteImport
          })
const VerktygHittaElomradeRoute = VerktygHittaElomradeRouteImport.update({
            id: '/verktyg/hitta-elomrade',path: '/verktyg/hitta-elomrade',getParentRoute: () => rootRouteImport
          })
const VerktygHittaNatagareRoute = VerktygHittaNatagareRouteImport.update({
            id: '/verktyg/hitta-natagare',path: '/verktyg/hitta-natagare',getParentRoute: () => rootRouteImport
          })
const VerktygMobilappRoute = VerktygMobilappRouteImport.update({
            id: '/verktyg/mobilapp',path: '/verktyg/mobilapp',getParentRoute: () => rootRouteImport
          })
const AdminAiAssistentIndexRoute = AdminAiAssistentIndexRouteImport.update({
            id: '/ai-assistent/',path: '/ai-assistent/',getParentRoute: () => AdminRoute
          })
const AdminAiAssistentThreadIdRoute = AdminAiAssistentThreadIdRouteImport.update({
            id: '/ai-assistent/$threadId',path: '/ai-assistent/$threadId',getParentRoute: () => AdminRoute
          })
const AdminArendenIndexRoute = AdminArendenIndexRouteImport.update({
            id: '/arenden/',path: '/arenden/',getParentRoute: () => AdminRoute
          })
const AdminArendenTicketIdRoute = AdminArendenTicketIdRouteImport.update({
            id: '/arenden/$ticketId',path: '/arenden/$ticketId',getParentRoute: () => AdminRoute
          })
const AdminArendenAutomatiskaSvarRoute = AdminArendenAutomatiskaSvarRouteImport.update({
            id: '/arenden/automatiska-svar',path: '/arenden/automatiska-svar',getParentRoute: () => AdminRoute
          })
const AdminArendenGranskningsloggRoute = AdminArendenGranskningsloggRouteImport.update({
            id: '/arenden/granskningslogg',path: '/arenden/granskningslogg',getParentRoute: () => AdminRoute
          })
const AdminArendenSignaturerRoute = AdminArendenSignaturerRouteImport.update({
            id: '/arenden/signaturer',path: '/arenden/signaturer',getParentRoute: () => AdminRoute
          })
const AdminArendenTestlageRoute = AdminArendenTestlageRouteImport.update({
            id: '/arenden/testlage',path: '/arenden/testlage',getParentRoute: () => AdminRoute
          })
const AdminIntegrationerGoogleWorkspaceRoute = AdminIntegrationerGoogleWorkspaceRouteImport.update({
            id: '/integrationer/google-workspace',path: '/integrationer/google-workspace',getParentRoute: () => AdminRoute
          })
const AdminKampanjCampaignIdRoute = AdminKampanjCampaignIdRouteImport.update({
            id: '/kampanj/$campaignId',path: '/kampanj/$campaignId',getParentRoute: () => AdminRoute
          })
const AdminLeadLeadIdRoute = AdminLeadLeadIdRouteImport.update({
            id: '/lead/$leadId',path: '/lead/$leadId',getParentRoute: () => AdminRoute
          })
const AdminStatistikIndexRoute = AdminStatistikIndexRouteImport.update({
            id: '/statistik/',path: '/statistik/',getParentRoute: () => AdminRoute
          })
const AdminStatistikKanalerRoute = AdminStatistikKanalerRouteImport.update({
            id: '/statistik/kanaler',path: '/statistik/kanaler',getParentRoute: () => AdminRoute
          })
const AdminStatistikKlickRoute = AdminStatistikKlickRouteImport.update({
            id: '/statistik/klick',path: '/statistik/klick',getParentRoute: () => AdminRoute
          })
const AdminStatistikScbRoute = AdminStatistikScbRouteImport.update({
            id: '/statistik/scb',path: '/statistik/scb',getParentRoute: () => AdminRoute
          })
const ElbolagElnatIndexRoute = ElbolagElnatIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ElbolagElnatRoute
          })
const ElbolagElnatSlugRoute = ElbolagElnatSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ElbolagElnatRoute
          })
const ElpriserHistorikIndexRoute = ElpriserHistorikIndexRouteImport.update({
            id: '/elpriser/historik/',path: '/elpriser/historik/',getParentRoute: () => rootRouteImport
          })
const HistoriskaElpriserManadMonthYearRoute = HistoriskaElpriserManadMonthYearRouteImport.update({
            id: '/historiska-elpriser/manad/$monthYear',path: '/historiska-elpriser/manad/$monthYear',getParentRoute: () => rootRouteImport
          })
const ProdukterKategoriIndexRoute = ProdukterKategoriIndexRouteImport.update({
            id: '/produkter/$kategori/',path: '/produkter/$kategori/',getParentRoute: () => rootRouteImport
          })
const ProdukterKategoriProduktRoute = ProdukterKategoriProduktRouteImport.update({
            id: '/produkter/$kategori/$produkt',path: '/produkter/$kategori/$produkt',getParentRoute: () => rootRouteImport
          })
const AdminStatistikKonverteringarIndexRoute = AdminStatistikKonverteringarIndexRouteImport.update({
            id: '/statistik/konverteringar/',path: '/statistik/konverteringar/',getParentRoute: () => AdminRoute
          })
const AdminStatistikKonverteringarGoalRoute = AdminStatistikKonverteringarGoalRouteImport.update({
            id: '/statistik/konverteringar/$goal',path: '/statistik/konverteringar/$goal',getParentRoute: () => AdminRoute
          })
const AdminStatistikScbKommunerRoute = AdminStatistikScbKommunerRouteImport.update({
            id: '/statistik/scb_/kommuner',path: '/statistik/scb/kommuner',getParentRoute: () => AdminRoute
          })
const ElpriserHistorikYearSlugIndexRoute = ElpriserHistorikYearSlugIndexRouteImport.update({
            id: '/elpriser/historik/$yearSlug/',path: '/elpriser/historik/$yearSlug/',getParentRoute: () => rootRouteImport
          })
const ElpriserHistorikYearSlugMonthRoute = ElpriserHistorikYearSlugMonthRouteImport.update({
            id: '/elpriser/historik/$yearSlug/$month',path: '/elpriser/historik/$yearSlug/$month',getParentRoute: () => rootRouteImport
          })





const AdminRouteChildren = {
  AdminAdministratorerRoute: AdminAdministratorerRoute,AdminAiChattRoute: AdminAiChattRoute,AdminAnnonsorerRoute: AdminAnnonsorerRoute,AdminAnvandareRoute: AdminAnvandareRoute,AdminAvtalsApiRoute: AdminAvtalsApiRoute,AdminAvtalsbytenRoute: AdminAvtalsbytenRoute,AdminBetygRoute: AdminBetygRoute,AdminBildrapportRoute: AdminBildrapportRoute,AdminDokumentdataRoute: AdminDokumentdataRoute,AdminElavtalRoute: AdminElavtalRoute,AdminElhandelsbolagRoute: AdminElhandelsbolagRoute,AdminFullmakterRoute: AdminFullmakterRoute,AdminGodkannandenRoute: AdminGodkannandenRoute,AdminHistorikRoute: AdminHistorikRoute,AdminInnehallRoute: AdminInnehallRoute,AdminInstallningarRoute: AdminInstallningarRoute,AdminIntresseRoute: AdminIntresseRoute,AdminKampanjerRoute: AdminKampanjerRoute,AdminKunderRoute: AdminKunderRoute,AdminKundregisterRoute: AdminKundregisterRoute,AdminLaddstationerRoute: AdminLaddstationerRoute,AdminLeadpartnersRoute: AdminLeadpartnersRoute,AdminLeadsRoute: AdminLeadsRoute,AdminLogotyperRoute: AdminLogotyperRoute,AdminMailmallarRoute: AdminMailmallarRoute,AdminMejlgranskningRoute: AdminMejlgranskningRoute,AdminMinaSidorRoute: AdminMinaSidorRoute,AdminNyheterRoute: AdminNyheterRoute,AdminNyhetsbrevRoute: AdminNyhetsbrevRoute,AdminOmdirigeringarRoute: AdminOmdirigeringarRoute,AdminPrisfilerRoute: AdminPrisfilerRoute,AdminProdukterRoute: AdminProdukterRoute,AdminPrognosApiRoute: AdminPrognosApiRoute,AdminRapporterRoute: AdminRapporterRoute,AdminRapportfilerRoute: AdminRapportfilerRoute,AdminReturerRoute: AdminReturerRoute,AdminSeoRoute: AdminSeoRoute,AdminSocialaMedierRoute: AdminSocialaMedierRoute,AdminSokinsikterRoute: AdminSokinsikterRoute,AdminSokresultatRoute: AdminSokresultatRoute,AdminSpotpriserRoute: AdminSpotpriserRoute,AdminTrenderRoute: AdminTrenderRoute,AdminVerktygRoute: AdminVerktygRoute,AdminIndexRoute: AdminIndexRoute,AdminAiAssistentThreadIdRoute: AdminAiAssistentThreadIdRoute,AdminArendenTicketIdRoute: AdminArendenTicketIdRoute,AdminArendenAutomatiskaSvarRoute: AdminArendenAutomatiskaSvarRoute,AdminArendenGranskningsloggRoute: AdminArendenGranskningsloggRoute,AdminArendenSignaturerRoute: AdminArendenSignaturerRoute,AdminArendenTestlageRoute: AdminArendenTestlageRoute,AdminIntegrationerGoogleWorkspaceRoute: AdminIntegrationerGoogleWorkspaceRoute,AdminKampanjCampaignIdRoute: AdminKampanjCampaignIdRoute,AdminLeadLeadIdRoute: AdminLeadLeadIdRoute,AdminStatistikKanalerRoute: AdminStatistikKanalerRoute,AdminStatistikKlickRoute: AdminStatistikKlickRoute,AdminStatistikScbRoute: AdminStatistikScbRoute,AdminAiAssistentIndexRoute: AdminAiAssistentIndexRoute,AdminArendenIndexRoute: AdminArendenIndexRoute,AdminStatistikIndexRoute: AdminStatistikIndexRoute,AdminStatistikKonverteringarGoalRoute: AdminStatistikKonverteringarGoalRoute,AdminStatistikScbKommunerRoute: AdminStatistikScbKommunerRoute,AdminStatistikKonverteringarIndexRoute: AdminStatistikKonverteringarIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const MinaSidorRouteChildren = {
  MinaSidorAnalyserRoute: MinaSidorAnalyserRoute,MinaSidorAnlaggningarRoute: MinaSidorAnlaggningarRoute,MinaSidorAvtalsforfragningarRoute: MinaSidorAvtalsforfragningarRoute,MinaSidorElavtalRoute: MinaSidorElavtalRoute,MinaSidorFaktureringRoute: MinaSidorFaktureringRoute,MinaSidorFakturorRoute: MinaSidorFakturorRoute,MinaSidorForbrukningRoute: MinaSidorForbrukningRoute,MinaSidorForfragningarRoute: MinaSidorForfragningarRoute,MinaSidorFullmakterRoute: MinaSidorFullmakterRoute,MinaSidorInstallningarRoute: MinaSidorInstallningarRoute,MinaSidorKontoinstallningarRoute: MinaSidorKontoinstallningarRoute,MinaSidorNotiserRoute: MinaSidorNotiserRoute,MinaSidorOffertforfragningarRoute: MinaSidorOffertforfragningarRoute,MinaSidorProfilRoute: MinaSidorProfilRoute,MinaSidorRapporterRoute: MinaSidorRapporterRoute,MinaSidorVerktygRoute: MinaSidorVerktygRoute,MinaSidorIndexRoute: MinaSidorIndexRoute
}

const MinaSidorRouteWithChildren = MinaSidorRoute._addFileChildren(MinaSidorRouteChildren)




const PartnerRouteChildren = {
  PartnerFaktureringRoute: PartnerFaktureringRoute,PartnerImportRoute: PartnerImportRoute,PartnerKampanjerRoute: PartnerKampanjerRoute,PartnerLeadsRoute: PartnerLeadsRoute,PartnerProfilRoute: PartnerProfilRoute,PartnerIndexRoute: PartnerIndexRoute
}

const PartnerRouteWithChildren = PartnerRoute._addFileChildren(PartnerRouteChildren)




const ElbolagElnatRouteChildren = {
  ElbolagElnatSlugRoute: ElbolagElnatSlugRoute,ElbolagElnatIndexRoute: ElbolagElnatIndexRoute
}

const ElbolagElnatRouteWithChildren = ElbolagElnatRoute._addFileChildren(ElbolagElnatRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AdminRoute: AdminRouteWithChildren,AiRoute: AiRoute,AiFakturaanalysRoute: AiFakturaanalysRoute,AiPrognoserRoute: AiPrognoserRoute,AngerKlagomalRoute: AngerKlagomalRoute,AnvandarvillkorRoute: AnvandarvillkorRoute,AppIntegritetspolicyRoute: AppIntegritetspolicyRoute,AppVillkorRoute: AppVillkorRoute,AuthRoute: AuthRoute,BekraftaEpostRoute: BekraftaEpostRoute,CompricerRoute: CompricerRoute,CookiesRoute: CookiesRoute,DagensElpriserRoute: DagensElpriserRoute,DataskyddspolicyRoute: DataskyddspolicyRoute,DiagramTabellerRoute: DiagramTabellerRoute,ElbrukRoute: ElbrukRoute,ElbyteRoute: ElbyteRoute,ElmarknadAiRoute: ElmarknadAiRoute,ElprisApiRoute: ElprisApiRoute,ElpriskollenRoute: ElpriskollenRoute,ElsklingRoute: ElsklingRoute,FelanmalanRoute: FelanmalanRoute,ForLlmsRoute: ForLlmsRoute,ForfraganForetagBrfRoute: ForfraganForetagBrfRoute,FragorSvarRoute: FragorSvarRoute,HittaElbolagRoute: HittaElbolagRoute,HittaElnatsomradeRoute: HittaElnatsomradeRoute,HittaElomradeRoute: HittaElomradeRoute,HittaNatagareRoute: HittaNatagareRoute,JamforOffertRoute: JamforOffertRoute,JobbaHosOssRoute: JobbaHosOssRoute,KalkylatorerRoute: KalkylatorerRoute,KassaRoute: KassaRoute,KompletteraAnlaggningsidRoute: KompletteraAnlaggningsidRoute,KompletteraAnlaggningsidTestRoute: KompletteraAnlaggningsidTestRoute,KompletteraUppgifterRoute: KompletteraUppgifterRoute,KompletteraUppgifterTestRoute: KompletteraUppgifterTestRoute,KontaktRoute: KontaktRoute,LamnaFeedbackRoute: LamnaFeedbackRoute,LamnaOmdomeRoute: LamnaOmdomeRoute,LamnaSynpunktRoute: LamnaSynpunktRoute,LoggaInRoute: LoggaInRoute,MinaElpriserRoute: MinaElpriserRoute,MinaSidorRoute: MinaSidorRouteWithChildren,MittAvtalRoute: MittAvtalRoute,MittElprisRoute: MittElprisRoute,MobilappRoute: MobilappRoute,MorgondagensElpriserRoute: MorgondagensElpriserRoute,OffertforfraganRoute: OffertforfraganRoute,OmOssRoute: OmOssRoute,PartnerRoute: PartnerRouteWithChildren,PartneransokanRoute: PartneransokanRoute,PersonligEnergianalysRoute: PersonligEnergianalysRoute,PressRoute: PressRoute,ProduktionsstatusRoute: ProduktionsstatusRoute,PrognosApiRoute: PrognosApiRoute,SaveraRoute: SaveraRoute,SkapaArendeRoute: SkapaArendeRoute,SokRoute: SokRoute,SokresultatRoute: SokresultatRoute,SokresultatTestRoute: SokresultatTestRoute,SolcellsofferterRoute: SolcellsofferterRoute,SpontanansokanRoute: SpontanansokanRoute,StartRoute: StartRoute,TackForetagRoute: TackForetagRoute,TackOffertRoute: TackOffertRoute,ValjLosenordRoute: ValjLosenordRoute,VerktygTjansterRoute: VerktygTjansterRoute,VilketElbolagRoute: VilketElbolagRoute,ZmartaRoute: ZmartaRoute,BatterierSlugRoute: BatterierSlugRoute,BatterierBatterikalkylatorRoute: BatterierBatterikalkylatorRoute,BatterierOffertRoute: BatterierOffertRoute,BliPartnerSlugRoute: BliPartnerSlugRoute,BloggSlugRoute: BloggSlugRoute,DagensSpotprisSlugRoute: DagensSpotprisSlugRoute,ElavtalSlugRoute: ElavtalSlugRoute,ElavtalAnvisatRoute: ElavtalAnvisatRoute,ElavtalAvtalsvaljarenRoute: ElavtalAvtalsvaljarenRoute,ElavtalBastaRoute: ElavtalBastaRoute,ElavtalBestallRoute: ElavtalBestallRoute,ElavtalBilligaRoute: ElavtalBilligaRoute,ElavtalBindaRoute: ElavtalBindaRoute,ElavtalBlackFridayRoute: ElavtalBlackFridayRoute,ElavtalBrfRoute: ElavtalBrfRoute,ElavtalBytRoute: ElavtalBytRoute,ElavtalFastRoute: ElavtalFastRoute,ElavtalForetagRoute: ElavtalForetagRoute,ElavtalForstaGangenRoute: ElavtalForstaGangenRoute,ElavtalFritidshusRoute: ElavtalFritidshusRoute,ElavtalJamforRoute: ElavtalJamforRoute,ElavtalJamforTestRoute: ElavtalJamforTestRoute,ElavtalKvartsprisRoute: ElavtalKvartsprisRoute,ElavtalLagenhetRoute: ElavtalLagenhetRoute,ElavtalManadsprisRoute: ElavtalManadsprisRoute,ElavtalMixprisRoute: ElavtalMixprisRoute,ElavtalPensionarRoute: ElavtalPensionarRoute,ElavtalPensionarerRoute: ElavtalPensionarerRoute,ElavtalPortfoljRoute: ElavtalPortfoljRoute,ElavtalRorligtRoute: ElavtalRorligtRoute,ElavtalSagUppRoute: ElavtalSagUppRoute,ElavtalStudentRoute: ElavtalStudentRoute,ElavtalStudenterRoute: ElavtalStudenterRoute,ElavtalTecknaRoute: ElavtalTecknaRoute,ElavtalTillsvidareRoute: ElavtalTillsvidareRoute,ElavtalTimprisRoute: ElavtalTimprisRoute,ElavtalVidFlyttRoute: ElavtalVidFlyttRoute,ElavtalVillaRoute: ElavtalVillaRoute,ElavtalVintersakratRoute: ElavtalVintersakratRoute,ElbolagSlugRoute: ElbolagSlugRoute,ElbolagBastaRoute: ElbolagBastaRoute,ElbolagBilligasteRoute: ElbolagBilligasteRoute,ElbolagBytRoute: ElbolagBytRoute,ElbolagElhandelRoute: ElbolagElhandelRoute,ElbolagElnatRoute: ElbolagElnatRouteWithChildren,ElbolagJamforRoute: ElbolagJamforRoute,ElhandelSlugRoute: ElhandelSlugRoute,ElmarknadenAvregleringenRoute: ElmarknadenAvregleringenRoute,ElmarknadenFramtidenRoute: ElmarknadenFramtidenRoute,ElmarknadenHistoriaRoute: ElmarknadenHistoriaRoute,ElmarknadenSaFungerarElmarknadenRoute: ElmarknadenSaFungerarElmarknadenRoute,ElnatSlugRoute: ElnatSlugRoute,ElpriserSlugRoute: ElpriserSlugRoute,ElpriserElomrade1Route: ElpriserElomrade1Route,ElpriserElomrade2Route: ElpriserElomrade2Route,ElpriserElomrade3Route: ElpriserElomrade3Route,ElpriserElomrade4Route: ElpriserElomrade4Route,ElpriserFastRoute: ElpriserFastRoute,ElpriserIdagRoute: ElpriserIdagRoute,ElpriserImorgonRoute: ElpriserImorgonRoute,ElpriserJamforRoute: ElpriserJamforRoute,ElpriserKvartsprisRoute: ElpriserKvartsprisRoute,ElpriserManadsprisRoute: ElpriserManadsprisRoute,ElpriserNordpoolRoute: ElpriserNordpoolRoute,ElpriserPrognosRoute: ElpriserPrognosRoute,ElpriserRorligtRoute: ElpriserRorligtRoute,ElpriserSe1Route: ElpriserSe1Route,ElpriserSe2Route: ElpriserSe2Route,ElpriserSe3Route: ElpriserSe3Route,ElpriserSe4Route: ElpriserSe4Route,ElpriserTimprisRoute: ElpriserTimprisRoute,HembatterierSlugRoute: HembatterierSlugRoute,HembatterierOffertRoute: HembatterierOffertRoute,HistoriskaElpriserRestRoute: HistoriskaElpriserRestRoute,JamforOfferterSlugRoute: JamforOfferterSlugRoute,KommersiellaBatterierSlugRoute: KommersiellaBatterierSlugRoute,KommersiellaBatterierOffertRoute: KommersiellaBatterierOffertRoute,KommersiellaSolcellerSlugRoute: KommersiellaSolcellerSlugRoute,KommersiellaSolcellerOffertRoute: KommersiellaSolcellerOffertRoute,KommunSlugRoute: KommunSlugRoute,LaddboxarSlugRoute: LaddboxarSlugRoute,LaddboxarLaddboxkalkylatorRoute: LaddboxarLaddboxkalkylatorRoute,LaddboxarOffertRoute: LaddboxarOffertRoute,LaddstationerSlugRoute: LaddstationerSlugRoute,LaddstolparSlugRoute: LaddstolparSlugRoute,LaddstolparOffertRoute: LaddstolparOffertRoute,NyheterSlugRoute: NyheterSlugRoute,OrdlistaTermRoute: OrdlistaTermRoute,PressreleaserSlugRoute: PressreleaserSlugRoute,RapporterSlugRoute: RapporterSlugRoute,RapporterElprisetISverigeRoute: RapporterElprisetISverigeRoute,SolcellerSlugRoute: SolcellerSlugRoute,SolcellerOffertRoute: SolcellerOffertRoute,SolcellerSolcellskalkylatorRoute: SolcellerSolcellskalkylatorRoute,SpotprisSlugRoute: SpotprisSlugRoute,SpotprisElomradeSe1Route: SpotprisElomradeSe1Route,SpotprisElomradeSe2Route: SpotprisElomradeSe2Route,SpotprisElomradeSe3Route: SpotprisElomradeSe3Route,SpotprisElomradeSe4Route: SpotprisElomradeSe4Route,SpotprisIdagRoute: SpotprisIdagRoute,SpotprisImorgonRoute: SpotprisImorgonRoute,SpotprisSe1Route: SpotprisSe1Route,SpotprisSe2Route: SpotprisSe2Route,SpotprisSe3Route: SpotprisSe3Route,SpotprisSe4Route: SpotprisSe4Route,SpotpriserAreaRoute: SpotpriserAreaRoute,VarmepumparSlugRoute: VarmepumparSlugRoute,VarmepumparOffertRoute: VarmepumparOffertRoute,VarmepumparVarmepumpskalkylatorRoute: VarmepumparVarmepumpskalkylatorRoute,VerktygHittaAnlaggningsIdRoute: VerktygHittaAnlaggningsIdRoute,VerktygHittaElavtalRoute: VerktygHittaElavtalRoute,VerktygHittaElbolagRoute: VerktygHittaElbolagRoute,VerktygHittaElomradeRoute: VerktygHittaElomradeRoute,VerktygHittaNatagareRoute: VerktygHittaNatagareRoute,VerktygMobilappRoute: VerktygMobilappRoute,BatterierIndexRoute: BatterierIndexRoute,BliPartnerIndexRoute: BliPartnerIndexRoute,BloggIndexRoute: BloggIndexRoute,DagensSpotprisIndexRoute: DagensSpotprisIndexRoute,ElavtalIndexRoute: ElavtalIndexRoute,ElbolagIndexRoute: ElbolagIndexRoute,ElhandelIndexRoute: ElhandelIndexRoute,ElmarknadenIndexRoute: ElmarknadenIndexRoute,ElnatIndexRoute: ElnatIndexRoute,ElpriserIndexRoute: ElpriserIndexRoute,HistoriskaElpriserIndexRoute: HistoriskaElpriserIndexRoute,JamforOfferterIndexRoute: JamforOfferterIndexRoute,KommersiellaBatterierIndexRoute: KommersiellaBatterierIndexRoute,KommersiellaSolcellerIndexRoute: KommersiellaSolcellerIndexRoute,KommunIndexRoute: KommunIndexRoute,LaddboxarIndexRoute: LaddboxarIndexRoute,LaddstationerIndexRoute: LaddstationerIndexRoute,LaddstolparIndexRoute: LaddstolparIndexRoute,NyheterIndexRoute: NyheterIndexRoute,OfferterIndexRoute: OfferterIndexRoute,OrdlistaIndexRoute: OrdlistaIndexRoute,PressreleaserIndexRoute: PressreleaserIndexRoute,ProdukterIndexRoute: ProdukterIndexRoute,RapporterIndexRoute: RapporterIndexRoute,SolcellerIndexRoute: SolcellerIndexRoute,SpotprisIndexRoute: SpotprisIndexRoute,VarmepumparIndexRoute: VarmepumparIndexRoute,VerktygIndexRoute: VerktygIndexRoute,HistoriskaElpriserManadMonthYearRoute: HistoriskaElpriserManadMonthYearRoute,ProdukterKategoriProduktRoute: ProdukterKategoriProduktRoute,ElpriserHistorikIndexRoute: ElpriserHistorikIndexRoute,ProdukterKategoriIndexRoute: ProdukterKategoriIndexRoute,ElpriserHistorikYearSlugMonthRoute: ElpriserHistorikYearSlugMonthRoute,ElpriserHistorikYearSlugIndexRoute: ElpriserHistorikYearSlugIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)